import type { ReactNode } from 'react';

/** Filtre d'une liste : « Tous » (null) puis les options en enfants (ex. <ReferenceOptions>) */
export function FilterSelect({
  label,
  allLabel,
  value,
  onChange,
  children,
}: {
  /** Intitulé pour les lecteurs d'écran (« Filtrer par rôle ») */
  label: string;
  /** Option sans filtre (« Tous les rôles ») */
  allLabel: string;
  value: string | null;
  onChange: (value: string | null) => void;
  children: ReactNode;
}) {
  return (
    <select
      aria-label={label}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      className="px-3 py-2 border border-slate-300 rounded-lg text-sm bg-card text-slate-700"
    >
      <option value="">{allLabel}</option>
      {children}
    </select>
  );
}
